<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getChallenge()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" class="btn btn-warning btn-ex mr-2" @click="alertUpgradeTier()"><i class="uil uil-trophy mr-2"></i> Upgrade Tier</button>
                                        <button type="submit" v-b-modal.modal-Challenge class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Challenge</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th></th>
                                                <th>Challenge Name</th>
                                                <th>Achievement Type</th>
                                                <th>Periode</th>
                                                <th>Status</th>
                                                <th>Total Participant</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in challenge.data" :key="data.id" v-on:click="editChallenge(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_challenge" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td v-on:click.stop="">
                                                    <button v-on:click="detailChallenge(data)" class="btn btn-primary">Challenge</button>
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.achievement_type}}</td>
                                                <td>
                                                    {{data.start_date | formatDate}} - {{data.end_date | formatDate}}
                                                </td>
                                                <td>
                                                    <label v-if="data.status === 'ON_PROGRESS'" class="badge badge-info">ON PROGRESS</label>
                                                    <label v-if="data.status === 'ON_SETUP'" class="badge badge-secondary">ON SETUP</label>
                                                    <label v-if="data.status === 'DONE'" class="badge badge-success">DONE</label>
                                                    <label v-if="data.status === 'WAITING'" class="badge badge-warning">WAITING</label>
                                                </td>
                                                <td>
                                                    <label class="badge badge-info">{{data.users.length}} Participant</label>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="challenge.total === 0" class="text-center no-data">Challenge data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="challenge"
                                                :sorting="sorting"
                                                @paginate="getChallenge()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Challenge Data Still Empty</h2>
                                    <p>On this page you can create challenge</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Challenge class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Challenge</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_challenge.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_challenge = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_challenge.length}}</span> challenge selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteChallenge()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_challenge="del_challenge" @getChallenge="_getChallenge(),del_challenge = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../challenge/ModalForm.vue'
    import moment from 'moment'


    export default {
        name: "Challenge",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_challenge:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getChallenge()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('ChallengeControl', {
                challenge: state => state.challenge,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.challenge.data ? this.del_challenge.length == this.challenge.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.challenge.data.forEach(function (challenge) {
                            selected.push(challenge.id);
                        });
                    }
                    this.del_challenge = selected;
                }
            }
        },
        methods: {
            ...mapActions('ChallengeControl', ['getChallenge','deleteChallenge','upgradeTier']),
            ...mapMutations('ChallengeControl', ['CLEAR_PARTNER','ASSIGN_FORM']),
            
            _getChallenge:function(){
                this.getChallenge().then(() => {
                    if(this.challenge.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            editChallenge:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Challenge')
            },
            detailChallenge:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-DetailChallenge')
            },
            alertDeleteChallenge:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this theme data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteChallenge(this.del_challenge).then(
                            this.$toast.success('Successfully Deleting Challenge'),
                            this.del_challenge = []
                        )
                    }
                })
            },
            alertUpgradeTier:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you to upgrade tier agent? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Upgrade',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.upgradeTier().then(
                            this.$toast.success('Successfully Upgrade Tier Agent'),
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_PARTNER()
        }
    };

</script>
